import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent
} from '@mui/material';
import QuickActionsCore from '../components/QuickActionsCore';
import RecentActivity from '../components/RecentActivity';

/**
 * QuickActionsPage - Unified scan hub for warehouse operations
 * Scan multiple items, then choose action to perform on all
 * Uses shared QuickActionsCore component
 */
export default function QuickActionsPage() {
  const location = useLocation();
  const [autoScanId, setAutoScanId] = useState(null);

  // Auto-scan equipment from URL parameter (QR code scan)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const equipmentId = params.get('equipment_id');

    if (equipmentId) {
      // Automatically scan the equipment from the QR code
      setAutoScanId(equipmentId);
    }
  }, [location.search]);

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quick Actions
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Scan equipment, then choose action to perform
      </Typography>

      {/* Quick Actions Core */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <QuickActionsCore autoScanId={autoScanId} />
        </CardContent>
      </Card>

      {/* Recent Activity */}
      <Box sx={{ mt: 4 }}>
        <RecentActivity limit={100} showHeader={true} autoRefresh={true} />
      </Box>
    </Container>
  );
}
